module.exports = __webpack_public_path__ + "2970957501abe1211b0f2413e72d827d.pdf";